import type { IconSvgObject } from './types';

const EnergyIcon: IconSvgObject = [
  ["path", { d: "M6.00015 12.9998L13.5 2.99997V11H18L10.5002 20.9998V12.9998H6.00015Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default EnergyIcon;
